export const emailRegexp = /^\S+@\S+$/i

export const externalLinkRegexp = /^(https?:)?\/\/.*/i
